import classNames from 'classnames'
import React from 'react'

import { Container } from '../container/container.js'
import { GridColumn } from '../grid/grid-column.js'
import { Grid } from '../grid/grid.js'
import { Image, ImageProps } from '../image/image.js'
import { SamsungFlexLogo } from '../logo/logo.js'

export interface HeroProps {
    image: ImageProps
    title?: string
    className?: string
    subTitle?: string
}

export const Hero = (props: HeroProps): JSX.Element => {
    const className: string = classNames('hero', props.className)

    return (
        <div className={className}>
            <Container className="hero__container">
                <Image {...props.image} className="hero__image" pictureClassName="hero__picture" />
                <Grid>
                    <GridColumn width={['xs-3', 'sm-9', 'md-5', 'xl-5']}>
                        <SamsungFlexLogo colors={['#fff', '#fff']} className="hero__logo" />
                        {props.title && <h1 className="hero__title">{props.title}</h1>}
                        {props.subTitle && <p className="h3 hero__subtitle">{props.subTitle}</p>}
                    </GridColumn>
                </Grid>
            </Container>
        </div>
    )
}
